module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "item",
    class: {
      active: _vm.active
    },
    style: ({
      zIndex: !_vm.active ? _vm.row : 10 - _vm.row
    }),
    attrs: {
      "tabindex": "0",
      "role": "button",
      "aria-pressed": _vm.active ? 'true' : 'false',
      "aria-label": _vm.ariaLabel
    },
    on: {
      "click": _vm.toogle,
      "keydown": [function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        $event.preventDefault();
        _vm.toogle($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "space", 32)) { return; }
        $event.preventDefault();
        _vm.toogle($event)
      }]
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "kernel",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "kernel-ring"
  }), _vm._v(" "), _c('span', {
    staticClass: "kernel-body"
  }), _vm._v(" "), _c('span', {
    staticClass: "kernel-sheen"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-88eea85a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Item.vue
// module id = 65
// module chunks = 2